

import React, { useState } from "react"
const LocationLabel = (props) => {

    return (
        <React.Fragment>
            <div className="col">

                <div className="text-muted mx-1" title="ویرایش لوکیشن" onClick={props.cleanLocation} >
                   <span className="text-danger"> {props.location}</span>
                    :  لوکیشن 
                    </div>
            </div>
        </React.Fragment>
    )
}
export default LocationLabel;

